import React, {  useState } from "react";
import Header from "./Header/Header";
import { Route, Routes } from "react-router-dom";
import Home from "./Home/Home";
import About from "./About/About";
import Portfolio from "./Portfolio/Portfolio";
import Service from "./Service/Service";
import Contact from "./Contact/Contact";
import Footer from "./Footer/Footer";
import OpacityLoading from "./Loading/OpacityLoading";
import { AnimatePresence } from "framer-motion";
import TodoList from "./ShowDesign/TodoList";



function MainComponent() {

  const [isLoading, setIsLoading] = useState(true);

  
  const spinner = document.getElementById("loading");
    if (spinner) {
      setTimeout(() => {
        spinner.style.display = "none";
        setIsLoading(false);
      },3000 );
    }

  return (
    
    <>
       {!isLoading  &&
        (
        <div>
          <OpacityLoading>
            <Header />
            <AnimatePresence>
              <Routes>
                <Route path="/" element={<Home />}></Route>
                <Route path="/about" element={<About />}></Route>
                <Route path="/portfolio" element={<Portfolio />}></Route>
                <Route path="/service" element={<Service />}></Route>
                <Route path="/contact_me" element={<Contact />}></Route>
                <Route path="/to_do" element={<TodoList />}></Route>
              </Routes>
              <Footer />
            </AnimatePresence>
          </OpacityLoading>
        </div>
      )}
    </>
  );
}

export default MainComponent;
